import { ComposeViewState } from 'owa-mail-compose-store';
import { RecipientsCollection } from 'owa-attachment-well-data/lib/utils/includeMostRecentAttachmentsInfoBarMessage';

// Exported for testing purposes only
export default function getRecipientWellValues(viewState: ComposeViewState): RecipientsCollection {
    return {
        toRecipients: viewState.toRecipientWell ? viewState.toRecipientWell.recipients : [],
        ccRecipients: viewState.ccRecipientWell ? viewState.ccRecipientWell.recipients : [],
        bccRecipients: viewState.bccRecipientWell ? viewState.bccRecipientWell.recipients : [],
    };
}
